export const formatToSelectOptions = (data, setFirst) => {
    const result = [];
    result[0] = data;
    let temp = data[0];
    while (setFirst && temp.children && temp.children[0]) {
        result.push(temp.children);
        temp = temp.children[0];
    }
    return result;
};

export const removeItem = (dataArr = [], data) => {
    const index = dataArr.findIndex(item => item.id === data.id);
    if (index !== -1) {
        dataArr.splice(index, 1);
    }
};

export const findInTree = (data, value, valueKey = 'id') => {
    if (!value) return;
    for (let i = 0; i < data.length; i++) {
        if (data[i][valueKey] === value) {
            return data[i];
        }
        if (data[i].children) {
            const temp = findInTree(data[i].children, value, valueKey);
            if (temp) {
                return temp;
            }
        }
    }
};

export const findPathInTree = (data, value, path, level) => {
    let finded = data.some(item => {
        path[level] = item;
        if (item.id === value.id) {
            // 把后面的清除掉
            path.splice(level + 1);
            return true;
        }
        if (!item.children) {
            return false;
        }
        return findPathInTree(item.children, value, path, level + 1);
    });
    // 如果没找到，要把当前层级后面的删掉
    if (!finded) {
        path.splice(level);
    }
    return finded;
};

export const getLeafData = (data, result = []) => {
    data.forEach(item => {
        if (!item.children) {
            return result.push(item);
        }
        getLeafData(item.children, result);
    });
    return result;
};
